const images = [
    {
            id:1,
            name:"Broken Hearts",
            tag:'photo_manipulation',
            img:'image/1.png'},
          
        
            {
                id:2,
                name:"King of Clover-Card",
                tag:'cards',
                img:"image/2.png"},

                {
                    id:3,
                    name:"Poster",
                    tag:'graphic_design',
                    img:"image/3.png"},

                
                        {
                            id:4,
                            name:"King of Diamonds-Card",
                            tag:'cards',
                            img:"image/4.png"},
                        
                            {
                                id:5,
                                name:"King of Hearts-Card",
                                tag:'cards',
                                img:"image/5.png"},

                                {
                                    id:6,
                                    name:"King of Hearts",
                                    tag:'photo_manipulation',
                                    img:"image/6.png"},

                                    {
                                        id:7,
                                        name:"King of Clover",
                                        tag:'photo_manipulation',
                                        img:"image/7.png"},


                                        {
                                            id:8,
                                            name:"King of Clubs-Card",
                                            tag:'cards',
                                            img:"image/8.png"},

                                            {
                                                id:9,
                                                name:"Midnight Love",
                                                tag:'photo_manipulation',
                                                img:"image/9.png"},
                                                {
                                                    id:10,
                                                    name:"Medival Night",
                                                    tag:'photo_manipulation',
                                                    img:"image/10.png"},
                                                    {
                                                        id:11,
                                                        name:"Nuns Night Out",
                                                        tag:'photo_manipulation',
                                                        img:"image/11.png"},
                                                        {
                                                            id:12,
                                                            name:"On the Road",
                                                            tag:'photo_manipulation',
                                                            img:"image/12.png"},
                                                            {
                                                                id:13,
                                                                name:"Purple Poster",
                                                                tag:'graphic_design',
                                                                img:"image/13.png"},
                                                                {
                                                                    id:14,
                                                                    name:"Queen of Clubs-Card",
                                                                    tag:'cards',
                                                                    img:"image/14.png"},
                                                                    {
                                                                        id:15,
                                                                        name:"Queen of Diamonds-Card",
                                                                        tag:'cards',
                                                                        img:"image/15.png"},
                                                                        {
                                                                            id:16,
                                                                            name:"Queen of Hearts-Card",
                                                                            tag:'cards',
                                                                            img:"image/16.png"},

                                                                            {
                                                                                id:17,
                                                                                name:"Queen of Spades-Card",
                                                                                tag:'cards',
                                                                                img:"image/17.png"},
                                                                                {
                                                                                    id:18,
                                                                                    name:"Queen of Clubs",
                                                                                    tag:'photo_manipulation',
                                                                                    img:"image/18.png"},
                                                                                    {
                                                                                        id:19,
                                                                                        name:"Queen of Hearts",
                                                                                        tag:'photo_manipulation',
                                                                                        img:"image/19.png"},
                                                                                        {
                                                                                            id:20,
                                                                                            name:"Queen of Spades",
                                                                                            tag:'photo_manipulation',
                                                                                            img:"image/20.png"},
                                                                                            {
                                                                                                id:21,
                                                                                                name:"Revelation",
                                                                                                tag:'photo_manipulation',
                                                                                                img:"image/21.png"},
                                                                                                {
                                                                                                    id:22,
                                                                                                    name:"Ruins",
                                                                                                    tag:'photo_manipulation',
                                                                                                    img:"image/22.png"},
                                                                                                    {
                                                                                                        id:23,
                                                                                                        name:"Victorian City",
                                                                                                        tag:'photo_manipulation',
                                                                                                        img:"image/23.png"},
                                                                                                        {
                                                                                                            id:24,
                                                                                                            name:"Queen of Diamonds",
                                                                                                            tag:'photo_manipulation',
                                                                                                            img:"image/24.png"}]
export default images